"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

require("./style.sass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Left = function Left() {
  return /*#__PURE__*/_react["default"].createElement(_context.MainContext.Consumer, null, function (data) {
    var _data$logoText;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (data === null || data === void 0 ? void 0 : (_data$logoText = data.logoText) === null || _data$logoText === void 0 ? void 0 : _data$logoText.length) > 80 ? 'longLogoText wizrd-header-logo' : "wizrd-header-logo"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "".concat(data !== null && data !== void 0 && data.logoUrl ? 'wizrd-logo-img' : ''),
      href: "/"
    }, data !== null && data !== void 0 && data.logoUrl ? /*#__PURE__*/_react["default"].createElement("img", {
      src: data === null || data === void 0 ? void 0 : data.logoUrl,
      alt: "logo",
      width: "184",
      height: "50"
    }) : null, data !== null && data !== void 0 && data.logoUrl ? '' : data !== null && data !== void 0 && data.logoText ? data === null || data === void 0 ? void 0 : data.logoText : 'Your Name Here'));
  });
};

var _default = Left;
exports["default"] = _default;